import { Component } from '@verndale/core'

class sectionNavigation extends Component {
  setupDefaults() {
    this.dom = {
      $select: this.el.querySelector('.section-navigation__select'),
      $options: Array.from(this.el.querySelectorAll('.section-navigation__link'))
    }

    this.selected = this.dom.$options.findIndex((option) => {
      return option.href === window.location.href
    })

    if (this.selected > -1) {
      this.dom.$options[this.selected].parentNode.classList.add('selected')
    }
  }

  addListeners() {
    this.dom.$select?.addEventListener('input', (e) => this.handleClick(e))
  }

  handleClick(e) {
    window.location.href = e.target.value
  }
}

export default sectionNavigation
